<!doctype html>
<html lang="en">
  <head>
  	<title>RA Login </title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">

	<link href="https://fonts.googleapis.com/css?family=Lato:300,400,700&display=swap" rel="stylesheet">

	<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">
    <link rel="stylesheet" href="../../../../assets/css/style.css">
ngif
	</head>

	<body>
		
	<section class="ftco-section">
		<div class ="container">
			
			
			<div class="row justify-content-center">
				<div class="col-md-6 col-lg-5">
					<div class=" p-4 p-md-5">
					<div *ngIf="errtext !='' && reconnecte!=true" class="alert alert-danger" style="text-align:center ; font-weight: normal;">
						<small>
							{{errtext}}
						</small>
					</div>
					<div *ngIf="errtext !=''  &&  reconnecte" class="alert alert-success" style="text-align: center;font-weight: normal;">
						<small>
							{{errtext}}
						</small>
					</div>
				<!-- <div class="icon d-flex align-items-center justify-content-center"> 
				     <span class="fa fa-user-o"></span> -->
		      	<div class=" d-flex align-items-center justify-content-center "> 
		      		
					<img src="/assets/img/whiteicon.png " class = "logo">

		      	</div>
				  <div class=" d-flex align-items-center justify-content-center "> 
					<div class="hh"  >Robo-Advisor</div>
					
		      	</div>
		
				<form class="login-form"  [formGroup]="loginForm" (ngSubmit)="onLogin()">

					<!-- email -->
		      		<div class="form-group">
		      			<input style="color:white" type="email" class="form-control rounded-left"  formControlName="email" placeholder= "saisissez l'adresse courriel" >
						  <div *ngIf="email.touched && email.errors?.required" class="invalid-feedback d-block">Adresse courriel est obligatoire</div>
						  <div *ngIf="email.touched && email.errors?.email" class="invalid-feedback d-block" >Adresse courriel invalide</div>
					</div>
				
					<!-- password  -->
	            	<div class="form-group inner-addon right-addon">
					<div class="input-group mx-auto md-d-flex">

	              		<input type="password" class="form-control rounded-left" id="password-field" formControlName="password" placeholder="saisissez le mot de passe" [type]="showPasswordOnPress ? 'text' : 'password'"
								 >
						<!-- add eye to show and hide password -->
						<div class="eye"
						(mousedown)="showPasswordOnPress = !showPasswordOnPress" (touchstart)="showPasswordOnPress = !showPasswordOnPress" 
						(mouseup)="showPasswordOnPress = !showPasswordOnPress" (touchend)="showPasswordOnPress = !showPasswordOnPress">
						<i alt="show" class="fas fa-eye eye-show" 
						
						[class.hide]="showPasswordOnPress"></i>
						<i alt="hide" class="fas fa-eye-slash eye-hide" 
						
						[class.hide]="!showPasswordOnPress"></i>
						</div>
						</div>
                  <div *ngIf="password.touched && password.hasError('required')" class="invalid-feedback d-block">mot de passe est obligatoire 
                 </div>
                
	           </div>
	            <!--confirm  password  -->
	            <div class="form-group">
	            	<button type="submit"  [disabled]="loginForm.invalid" class="btn btn-primary rounded submit p-3 px-5">CONNEXION</button>
	            </div>
               <div class="form-group d-md-flex justify-content-center links"  style=" display:flex; margin-top: 110px;">
				   <div class="mobml" >
					<a href=# [routerLink]="['/reset']"  routerLinkActive="router-link-active" style="color:white">Mot de passe oublié ?</a>
					</div>
						<!-- model start here
					<div class="w-50 text-md-right">
						<a href="#" (click)="reconnect(mymodal)"  >Reconnecte-moi</a>
					</div>     
				 -->
					 <ng-template #mymodal let-modal>
						<div class="modal-header">
						  <h4 class="modal-title" id="modal-basic-title" style="color:#6600ff; font-weight: bold; font-size: 18px;">RECONNECTE-MOI</h4>
						  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
							<span aria-hidden="true">×</span>
						  </button>
						</div>
						<div class="modal-body" style="font-size: 16px;">
							<p style="font-weight: bloder ;">Merci de saisir votre adresse courriel</p>
							<form [formGroup]="reconnectForm" (ngSubmit)="reconnectok();modal.dismiss('Cross click')">
								<div class="form-group">
								<div style="margin-top:15px ;">
									<input type="email" class="form-control rounded-left"  formControlName="email" placeholder="saisissez l'adresse courriel" >
									<div *ngIf="email2.touched && email2.errors?.required" class="invalid-feedback d-block">Adresse courriel est obligatoire</div>
									<div *ngIf="email2.touched && email2.errors?.email" class="invalid-feedback d-block" >Adresse courriel invalide</div>
							</div>
						  </div>
						  
						
						<div class="modal-footer">
							<div class="form-group" >

						 	<button type="button" class="btn modele2" data-dismiss="modal" (click)="modal.dismiss('Cross click')" style="margin-right: 5px;" >Fermer</button>
						  	<button  type="submit"  [disabled]="reconnectForm.invalid"  class="btn  modele" data-dismiss="modal" style="margin-right: -15px;" >Confirmer</button>
						</div>
						  <!-- <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">Ok</button> -->
						</div>
					</form>
					</div>
					  </ng-template>


					<!-- model end here -->
	            </div>
               <hr style="width:100%; background-color: #6600ff;">
			    <div class="form-group md-d-flex">
                    <div      class=" d-flex justify-content-center links"  style="font-size: 15px;color:white">
                     Vous n'avez pas de compte?  </div>
					 <div      class=" d-flex justify-content-center links"  style="font-size: 15px;color:white">
						<a [routerLink]="['/signup']" style="font-weight: bold;color:white" routerLinkActive="router-link-active" class="ml-2">s'inscrire maintenant </a>
					</div>
                 </div>


				 
				</form>
			</div>
	        
				</div>
			</div>
		</div>
	</section>
	
	

<script src="../../../../assets/js/jquery.min.js"></script>
<script src="../../../../assets/js/popper.js"></script>
<script src="../../../../assets/js/bootstrap.min.js"></script>
<script src="../../../../assets/js/main.js"></script>
</body>
</html>

